import { Component, OnInit } from '@angular/core';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { LookupService } from 'src/app/share/services/lookup/lookup.service';
import { ConfirmationPopupComponent } from 'src/app/share/popups/confirmation-popup/confirmation-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CommonService } from 'src/app/share/services/common/common.service';
@Component({
  selector: 'app-departments-list',
  templateUrl: './departments-list.component.html',
  styleUrl: './departments-list.component.scss'
})
export class DepartmentsListComponent implements OnInit {
  public readonly faEdit = faEdit;
  public readonly faTrash = faTrash;
  isEdit: boolean = false;
  selectedDepartment: any = null;
  openDepartmentPanel: boolean = false;
  selfDetails: any;
  companyId: any;
  page: number = 0;
  totalRecords: number = 0;
  errorMessage: string;
  isErrorToster: boolean = false;
  isSuccessToster: boolean = false;
  tosterMessage: any;
  loadRecords: boolean = false;
  departments: any;

  constructor(private readonly lookupService: LookupService,
     private readonly modal: NgbModal, 
     private readonly storageService: StorageService,
     public readonly commonService: CommonService,
    ) { }

  ngOnInit(): void {
    this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    if (this.selfDetails) {
      this.companyId = this.selfDetails.company
    }
    this.getDepartmentsList(this.page);
    this.getDepartmentCount();
  }


  isEditDepartment(department: any) {
    this.selectedDepartment = department;
    this.openDepartmentPanel = true;
    this.isEdit = true;
  }

  closeDepartmentPanel() {
    this.openDepartmentPanel = false;
    this.selectedDepartment = null;
  }

  onPageChange(event: any): void {
    this.page = event.page;
    this.getDepartmentsList(this.page)
  }

  getDepartmentsList(page: any) {
    this.loadRecords = true;
    const params: any = {
      page: page,
    }
    this.lookupService.getDepartmentList(this.companyId, params)?.subscribe({
      next: (res) => {
        if (res.status === "success") {
          this.loadRecords = false;
          this.departments = res.data
        }
      },
      error: (error) => {
        this.errorMessageFunction(error?.error?.message);
      }
    })
  }

  deleteDepartment(department: any) {

    let dialogRef = this.modal.open(ConfirmationPopupComponent, { keyboard: false, backdrop: "static" });

    if (dialogRef?.componentInstance) {
      dialogRef.componentInstance.header = 'Delete Confirm';
      dialogRef.componentInstance.message = `Are you sure you want to delete ${department.name}`;
      dialogRef.componentInstance.lableName = 'Delete';
      dialogRef.result.then(
        (result) => {
          if (result) {
            this.lookupService.deleteDepartment(this.companyId, department?._id).subscribe({
              next: (res) => {
                if (res.status === "success") {
                  this.page= this.departments.length==1 ? this.page-1 : this.page;
                  this.getDepartmentsList(this.page);
                  this.getDepartmentCount();
                  this.successMessageFunction("Department is deleted successfully")
                }
              },
              error: (error) => {
                this.errorMessageFunction(error?.error?.message);
              }
            });
          }
        },
      );
    }
  }

  getDepartmentCount() {
    this.lookupService.getDepartmentCount(this.companyId)?.subscribe({
      next: (res) => {
        if (res.status === "success") {
          this.totalRecords = res.data;
        }
      },
      error: (err) => {
        this.errorMessageFunction(err?.error?.message)
      }
    })
  }

  errorMessageFunction(message: any) {
    this.errorMessage = message;
    this.isErrorToster = true;
    this.tosterMessage = message;
  }

  successMessageFunction(message: any) {
    this.isSuccessToster = true;
    this.tosterMessage = message;
  }

  successTosterFromAddDepartmentComponent(message: any) {
    this.isSuccessToster = true;
    this.tosterMessage = message;
    this.getDepartmentsList(0);
    this.getDepartmentCount();
  }

  closingToster(value : any){
    this.isErrorToster=value;
    this.isSuccessToster=value;
    this.tosterMessage="";
  }
  
   hasEditAccess(department: any): boolean {
    if (!this.commonService.hasAllowedAction()) {
      return false;
    }
    return department?.visibleTo?.includes(this.selfDetails?.company);
  }

}
